<template>
  <el-select
    v-model="schoolSelect"
    filterable
    remote
    reserve-keyword
    size="mini"
    :placeholder="placeholder"
    :remote-method="remoteQuery"
    :loading="loading"
    :disabled="disable"
    :clearable="clearable"
    @change="onSelectedSchool($event)"
    @clear="onClearSelect()">
    <el-option v-for="item in schoolList" :key="item.value" :label="item.label" :value="item" />
  </el-select>
</template>
<script>
export default {
  name: 'LoveSearchSchool',
  props: {
    disable: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '搜索学校名称'
    },
    selected: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      schoolList: [],
      schoolSelect: this.selected,
      list: [],
      loading: false
    }
  },
  methods: {
    initData(query) {
      if (query !== '') {
        //远程搜索机构
        this.$api.commonApi.commonIndex.listSchool({ which: 'name', like: query })
          .then(response => {
            //设置机构的选择项
            var allOrds = response.data.lists;
            this.list = allOrds.map(item => { //组装，只需要id和name
              return { value: item.id, label: item.name, city_id: item.city_id };
            });
            console.log(this.list)
          });
      }
    },
    remoteQuery(query) {
      if (query !== '') {
        this.loading = true;
        this.initData(query);
        setTimeout(() => {
          this.loading = false;
          this.schoolList = this.list.filter(item => {
            return item.label.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.schoolList = [];
      }
    },
    onSelectedSchool(event) {
      console.log(event)
      this.$emit('change', event)
    },
    onClearSelect() {
      this.schoolSelect = ''
      console.log("clear event")
      this.$emit('clear')
    },
  },
  watch: {
    selected(val) {
      this.schoolSelect = val
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/search/school.vue